module.exports = __webpack_public_path__ + "static/media/16UNODC16.f774930f.jpg";